module.exports = __webpack_public_path__ + "img/web5.05341919.png";